import { OrganizationComponent } from "../../../components/OrganizationComponent/OrganizationComponent";

export const AdminConsoleOrganizations = () => {

    return (
        <OrganizationComponent 
            isAdminPage
        />
    );
}